import styled, { css } from 'styled-components';

export const TableScroll = styled.div`
  overflow-x: auto;
  width: 100%;
`;

export const PaginationNav = styled.nav`
  display: flex;
  justify-content: center;
`;

export const DataTable = styled.table`
  ${({ theme }) => css`
    width: 100%;
    border-collapse: collapse;
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[30]};
    background-color: ${theme.v3.colors.neutral[100]};
  `}
`;

export const HeaderCell = styled.th`
  ${({ theme }) => css`
    padding: ${theme.v3.spacing.xxxs};
    font-weight: ${theme.v3.font.weights.medium};
    text-align: left;
    vertical-align: middle;
    border-bottom: ${theme.v3.border.width.thin} solid ${theme.v3.colors.neutral[95]};
    background-color: ${theme.v3.colors.neutral[100]};
  `}
`;

export const BodyCell = styled.td`
  ${({ theme }) => css`
    padding: ${theme.v3.spacing.xxxs};
    font-weight: ${theme.v3.font.weights.regular};
    text-align: left;
    vertical-align: middle;
    border-bottom: ${theme.v3.border.width.thin} solid ${theme.v3.colors.neutral[95]};
    background-color: ${theme.v3.colors.neutral[100]};
  `}
`;

export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;

export const SortHeaderButton = styled.button`
  ${({ theme }) => css`
    margin: 0;
    padding: 0;
    border: none;
    background: none;
    font: inherit;
    font-weight: ${theme.v3.font.weights.medium};
    color: inherit;
    cursor: pointer;
    text-align: left;

    &:hover {
      text-decoration: underline;
    }

    &:focus {
      outline: ${theme.v3.border.width.medium} solid ${theme.v3.colors.brand.snappyBlue[50]};
      outline-offset: 2px;
    }
  `}
`;
